// Product usage reporting to the SaaS API (video renders and agent
// generations). Configured at build time via VITE_APP_SAAS_URL +
// VITE_APP_SAAS_API_KEY (workspace API key with `write` scope). When not
// configured, reporting is a no-op.
const SAAS_URL = process.env.VITE_APP_SAAS_URL || ""
const SAAS_API_KEY = process.env.VITE_APP_SAAS_API_KEY || ""

export const USAGE_VIDEO_RENDER = "video_render"
export const USAGE_AGENT_GENERATION = "agent_generation"

export const isUsageReportingEnabled = () => Boolean(SAAS_URL && SAAS_API_KEY)

export const reportUsage = async (
  type: string,
  metadata: Record<string, unknown> = {}
): Promise<boolean> => {
  if (!isUsageReportingEnabled()) return false
  try {
    const response = await fetch(`${SAAS_URL.replace(/\/+$/, "")}/api/v1/usage/record`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SAAS_API_KEY}`,
      },
      body: JSON.stringify({ type, quantity: 1, metadata }),
    })
    return response.ok
  } catch {
    return false
  }
}

export interface UsageCheck {
  allowed: boolean
  used: number
  limit: number
  remaining: number
}

// Returns null when usage reporting is not configured or the SaaS is
// unreachable (fail-open: the editor keeps working offline).
export const checkUsage = async (type: string, quantity = 1): Promise<UsageCheck | null> => {
  if (!isUsageReportingEnabled()) return null
  try {
    const response = await fetch(`${SAAS_URL.replace(/\/+$/, "")}/api/v1/usage/check`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SAAS_API_KEY}`,
      },
      body: JSON.stringify({ type, quantity }),
    })
    if (!response.ok) return null
    const payload = await response.json()
    return payload?.data ?? null
  } catch {
    return null
  }
}
